import Vue from "vue";
import Router from "vue-router";
import api from './../api/activityLog.js';
import _ from "lodash";


Vue.use(Router);

const routerOptions = [
    {
        path: "/",
        name: "public",
        visible: false,

    },
    {
        path: "/login",
        name: "login",
        visible: false,
    },
    {
        path: "/register",
        name: "register",
        visible: false,
    },
    {
        path: '/home',
        name: 'home',
        visible: false,
        meta: {
            title: 'Inicio'
        }
    },
    {
        path: "/users",
        name: "users",
        meta: {
            title: "Usuarios / Gestión de Usuarios",
            permissions: [
                "get-users",
                "store-users",
                "update-users",
                "delete-users",
                "get-abilities",
                "store-abilities",
                "update-abilities",
                "delete-abilities",
                "get-roles",
                "store-roles",
                "update-abilities",
                "delete-abilities",
            ],
        },
        visible: true,
    },
    {
        path: '/operativeStructure',
        name: 'operativeStructure',
        meta: {
            title: "Estructura operativa",
            permissions: [
                'get_plants_aras_sub',
                'store_plants_areas_sub',
                'update_plants_aras_sub',
                'desactivate_plants_aras_sub'
            ],
        },
        visible: false,
    },
    {
        path: '/catalogs',
        name: 'catalogs',
        meta: {
            title: "Catálogos",
            permissions: [
                'get_plants_aras',
                'store_plants_areas',
                'update_plants_aras',
                'desactivate_plants_aras',
                'get_plants_aras_sub',
                'store_plants_areas_sub',
                'update_plants_aras_sub',
                'desactivate_plants_aras_sub'
            ],
        },
        visible: false,
    },
    {
        path: '/catalogs/plants',
        name: 'catalogs/plants',
        meta: {
            title: "Catálogos / Plantas",
            permissions: [
                'get_plants_aras',
                'store_plants_areas',
                'update_plants_aras',
                'desactivate_plants_aras',
            ],
        },
        visible: false,
    },
    // {
    //     path: '/catalogs/plants_areas',
    //     name: 'catalogs/plants_areas',
    //     meta: {
    //         title: "Catálogos / Áreas de producción",
    //         permissions: [
    //             'get_plants_aras_sub',
    //             'store_plants_areas_sub',
    //             'update_plants_aras_sub',
    //             'desactivate_plants_aras_sub'
    //         ],
    //     },
    //     visible: true,
    // },
    {
        path: '/catalogs/component',
        name: 'catalogs/component',
        meta: {
            title: "Catálogos / Componentes",
            permissions: [
                'get_equipment_general_component',
                'store_equipment_general_component',
                'update_equipment_general_component',
                'desactivate_equipment_general_component'
            ],
        },
        visible: true,
    },
    {
        path: '/catalogs/failures',
        name: 'catalogs/failures',
        meta: {
            title: "Catálogos / Fallas",
            permissions: [
                'get_equipment_general_failure',
                'store_equipment_general_failure',
                'update_equipment_general_failure',
                'desactivate_equipment_general_failure',
            ],
        },
        visible: true,
    },
    {
        path: '/catalogs/failuretypes',
        name: 'catalogs/failuretypes',
        meta: {
            title: "Catálogos / Tipo de fallas",
            permissions: [
                'get_failure_type',
                'update_failure_type',
                'store_failure_type',
                'delete_faulure_type',
            ],
        },
        visible: true,
    },
    {
        path: '/equipment',
        name: 'equipment',
        meta: {
            title: "Equipos/ Gestión de equipos",
            permissions: [
                'get_equipment',
                'store_equipment',
                'update_equipment',
                'desactivate_equipment',
            ],
        },
        visible: true,
    },
    {
        path: '/equipment/equipment_general',
        name: 'equipment/equipment_general',
        meta: {
            title: "Equipos / Equipos genéricos",
            permissions: [
                'get_equipment_general',
                'store_equipment_general',
                'update_equipment_general',
                'get_equipment_general_component',
                'store_equipment_general_component',
                'update_equipment_general_component',
                'desactivate_equipment_general_component',
                'get_equipment_general_failure',
                'store_equipment_general_failure',
                'update_equipment_general_failure',
                'desactivate_equipment_general_failure',
            ],
        },
        visible: true,
    },
    {
        path: '/delayEvent',
        name: 'delayEvent',
        meta: {
            title: "Demoras/ Gestión eventos de demora",
            permissions: [
                'get_delay_event',
                'store_delay_event',
                'update_delay_event',
                'delate_delay_event',
            ],
        },
        visible: true,
    },
    {
        path: "/logout",
        name: "logout",
        visible: false,
    },
    {
        path: "/kpis/kpiEquipment",
        name: "kpis/kpisEquipment",
        meta: {
            title: "KPIs/ Equipo",
            permissions: [
                'get_kpis_equipment'
            ],
        },
        visible: false,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            permissions: [
                'view_dashboard'
            ],
        },
        visible: true,
    },
    // {
    //     path: '/delayEventPlanned',
    //     name: 'delayEventPlanned',
    //     meta: {
    //         title: "Paros programados/ Gestión de paros programados",
    //         permissions: ['store_delay_event_massive'],
    //     },
    //     visible: true,
    // },
    //Cada seccion es independiente de otra pero se recomienda ponerlas en el orden de el NavigationMenu.vue
    {
        path: '/industrialReveal/iot',
        name: 'industrialReveal/iot',
        visible: true,
        meta: {
            title: 'Industrial Reveal',
            permissions: [],
        }
    },
    {
        path: '/industrialReveal/measurepoint',
        name: 'industrialReveal/measurepoint',
        visible: true,
        meta: {
            title: 'Puntos de medición',
            permissions: [],
        }
    },
    {
        path: '/delayEventPlannedControl',
        name: 'delayEventPlannedControl',
        meta: {
            title: "Control de paros programados/ Gestión de descripciones",
            permissions: ['get_failure_scheduled', 'store_failure_scheduled', 'auth_failure_scheduled'],
        },
        visible: true,
    },
    {
        path: '/analysis/availability',
        name: 'analysis/availability',
        meta: {
            title: "Disponibilidad",
            permissions: ['view_dashboard'],
        },
        visible: true,
    },
    {
        path: '/analysis/pareto',
        name: 'analysis/pareto',
        meta: {
            title: "Análisis de demoras",
            permissions: ['view_dashboard'],
        },
        visible: true,
    },
    // {
    //     path: '/analysis/charts',
    //     name: 'analysis/charts',
    //     meta: {
    //         title: "Análisis de demoras (Nuevo)",
    //         permissions: ['view_dashboard'],
    //     },
    //     visible: true,
    // },

];

// Rutas
const routes = routerOptions.map((r) => {
    return {
        ...r,
        component: () => import(`../components/${r.name}/index-component.vue`),
    };
});

const router = new Router({
    //mode: "history",
    base: __dirname,
    routes,
});

router.beforeEach((to, from, next) => {
    const pathModule = (_.split(to.meta.title, '/'))
    const module = pathModule[0];
    const subModule = pathModule[1];
    (to.name != 'login') ? api.storeActivityLog({ action: 'View', entity: 'User', module: module, sub_module: !_.isUndefined(subModule) ? subModule : module }) : null;
    next()
})

export default router;
